'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['network', 'user', 'toggle'],
    computed: {
        isUserSelf: function isUserSelf() {
            if (this.toggle === false) {
                return false;
            }
            var user = this.$state.getUser(this.network.id, this.network.nick);
            return this.user === user;
        },
        shouldShowStatus: function shouldShowStatus() {
            if (this.network.state !== 'connected') {
                return false;
            }

            var awayNotifyEnabled = this.network.ircClient.network.cap.isEnabled('away-notify');
            return this.$state.setting('buffers.who_loop') || awayNotifyEnabled;
        }
    },
    methods: {
        toggleSelfAway: function toggleSelfAway() {
            if (this.isUserSelf) {
                var val = this.user.isAway();
                this.network.ircClient.raw('AWAY', val ? '' : 'Currently away');
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["AwayStatusIndicator"]
window._kiwi_exports.components.AwayStatusIndicator = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AwayStatusIndicator.vue
// module id = j6jx
// module chunks = 1